import classNames from 'classnames';
import React from 'react';

const styles = require('./Badge.module.scss');

export type BadgeVariant = 'neutral' | 'info' | 'success' | 'warning' | 'error';

export interface BadgeProps {
  'aria-label'?: string;
  children?: React.ReactNode;
  className?: string;
  id?: string;
  variant?: BadgeVariant;
}

const Badge: React.FC<BadgeProps> = ({
  'aria-label': ariaLabel,
  children,
  className,
  id,
  variant = 'neutral',
}) => (
  <span
    id={id}
    className={classNames(styles.wrapper, className)}
    role={ariaLabel ? 'status' : undefined}
    aria-label={ariaLabel}
  >
    <span className={classNames(styles.badge, styles[variant])} aria-hidden="true" />
    {children && <span className={styles.label}>{children}</span>}
  </span>
);

export default Badge;
